const FLOTIQ_TO_MAGENTO_PRODUCT_ATTRIBUTE_KEYS_MAP = {
    flavour: "flavor_label",
    color: "color_label",
};
const hasProductType = (productType, flotiqStore) => {
    if (!flotiqStore.product_types) {
        return false;
    }
    return flotiqStore.product_types.some((type) => type.key === productType && type.is_available === "true");
};
const checkStoreEligibility = (store, product, filterByCartAvailabilityEnabled) => {
    const checkStoreLocatorCategory = (category) => {
        const productAttribute = store.product_attributes?.find((productAttribute) => productAttribute.category === category);
        if (!productAttribute) {
            return hasProductType(category, store);
        }
        const magentoKey = FLOTIQ_TO_MAGENTO_PRODUCT_ATTRIBUTE_KEYS_MAP[productAttribute.key];
        if (!product[magentoKey]) {
            return false;
        }
        if ((filterByCartAvailabilityEnabled && magentoKey === filterByCartAvailabilityEnabled) ||
            filterByCartAvailabilityEnabled === "both") {
            const status = productAttribute.values.some(({ value }) => value === product[magentoKey]);
            return status;
        }
        return true;
    };
    const storeLocatorCategoryNames = product.categories.map(({ store_locator_name }) => store_locator_name);
    return storeLocatorCategoryNames.every(checkStoreLocatorCategory);
};
export const getStoresFilteredByProductAttributes = (stores, cartItems, filterByCartAvailabilityEnabled) => {
    return stores.filter((store) => {
        const hasStore = cartItems.every((cartItem) => checkStoreEligibility(store, cartItem, filterByCartAvailabilityEnabled));
        return hasStore;
    });
};
//# sourceMappingURL=getStoresFilteredByProductAttributes.js.map